function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 28 18"
}, props), React.createElement("path", {
  d: "M22.91 2.4H12.726v8.4H2.545V0H0v18h2.545v-3.6h22.91V18H28V7.2c0-1.273-.536-2.494-1.491-3.394a5.252 5.252 0 00-3.6-1.406zM7.635 9.6c1.013 0 1.984-.38 2.7-1.054A3.499 3.499 0 0011.454 6c0-.955-.402-1.87-1.118-2.546a3.939 3.939 0 00-2.7-1.054c-1.012 0-1.983.38-2.7 1.054A3.499 3.499 0 003.818 6c0 .955.402 1.87 1.118 2.546a3.939 3.939 0 002.7 1.054z",
  fill: "#7B7B7B"
})));